import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ResultView from "./ResultViewComponent";
import { verifyEmail } from "../../../redux/slices/careersSlices.reducer";
import { toast } from "react-toastify";
import { careersMessages } from "../../../config/careers/careers";
import { useParams, useNavigate } from "react-router-dom";
import { clientIds } from "../../../config/clients/clients";
import Image from "../../../component/image/Image";
import zealLogo from "../../../assets/images/clients/zeal-logo.png";
import useClientConfig from "../../../config/careers/clientConfig";

const VerifyEmail = (props: any) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const pageParams = useParams();
    const settingsLoaded = useSelector((state: any) => state.careers.settingsLoaded);
    const clientConfig = useSelector((state: any) => state.careers.cliendConfig);
    const {clientSiteSettings} = useClientConfig();
    const templateName = clientSiteSettings?.templateName;
    const email = clientConfig?.data?.data?.clientSettings?.hrEmail || clientConfig?.data?.data?.clientSettings?.email;

    const [apiLoad, setApiLoad] = useState(false);
    const [verificationToken, setVerificationToken] = useState<string>("");
    const [verificationResult, setVerificationResult] = useState<string>("");
    const [verificationMessage, setVerificationMessage] = useState<string>("");
    const verificationStatus = useSelector((state: any) => state.careers.verificationStatus);

    useEffect(() => {
        if(pageParams?.token) {
            setVerificationToken(pageParams?.token);
        }
        else{
            //TODO : insert redirect to 404 or listings
        }
    }, [location.pathname]);

    //Ensures preloaded api data is present or done loading
    useEffect(() => {
        if(settingsLoaded === true) {
            setApiLoad(true);
        } else {
            setApiLoad(false);
        }
    }, [settingsLoaded]);

    useEffect(() => {
        if( apiLoad === true ) {
            dispatch<any>(verifyEmail(verificationToken));
        }
    }, [verificationToken]);

    useEffect(() => {
        if( apiLoad === true ) {
            let verificationAPIResponse = verificationStatus?.data;
            setVerificationResult(verificationAPIResponse?.statusCode);
            if (verificationAPIResponse.statusCode === 200) {
                setVerificationMessage(verificationAPIResponse?.result);
            }
            else if (verificationAPIResponse.statusCode === 400) {
                setVerificationMessage(verificationAPIResponse?.result);
            }
            else {
                const errMsg = careersMessages.apiErrorMessage?.replace("{{EMAIL}}", email);
                toast(errMsg, {
                    type: "error",
                    autoClose: 60000,
                });
            }
        }
    }, [verificationStatus]);

    const redirectListing = () => {
        navigate("/");
    };

    return(
        <>
            <div className= "job-alert-email-subheader">               
                <div className="job-alert-email-head">
                    {
                    (templateName === "template_4") ?
                    <>
                        <button onClick={redirectListing}>
                        <Image src={zealLogo} alt="Zeal Logo" />
                        </button>
                    </>
                    : ""
                    }
                    Job Alerts
                </div>
              </div>
            <ResultView 
                result={verificationResult}
                message={verificationMessage}
            />
        </>
    );
};

export default VerifyEmail;